import React from 'react';
import { LinkModel, ModuleBaseModel, ModuleBasePropsModel } from '@/types';
import ReportHero, { ReportHeroModel } from './ReportHero/ReportHero';

type ReportStubModel = ModuleBaseModel<
  {
    breadCrumbs: {
      breadcrumb: LinkModel[];
    };
    hero: ReportHeroModel['props'];
  } & ModuleBasePropsModel
>;

const ReportStub = (data: ReportStubModel) => {
  const {
    props: {
      hero,
      //  breadCrumbs
    },
  } = data;

  return (
    <ReportHero
      {...{
        id: data.id,
        moduleName: data.moduleName,
        props: {
          ...hero,
          stub: true,
          heroTextColour: 'Light',
          anchorTextColour: 'White',
          // breadcrumbs: breadCrumbs?.breadcrumb,
        },
      }}
    />
  );
};

export default ReportStub;
